import { createGlobalStyle } from 'styled-components'

export const Fonts = createGlobalStyle`
@font-face {
  font-family: "Skolar Sans PE condensed";
  src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff2")
      format("woff2"),
    url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff")
      format("woff");
  font-weight: 400;
  font-style: normal;
}
  
@font-face {
  font-family: "Skolar PE";
  src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Regular_v3.5.woff2") format("woff2"), url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Regular_v3.5.woff") format("woff");
  font-weight: 400;
  font-style: normal;
  }

  @font-face {
    font-family: "Skolar PE";
    src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Italic_v3.5.woff2") format("woff2"), url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Italic_v3.5.woff") format("woff");
    font-weight: 400;
    font-style: italic;
  }
`
